"use strict";

exports.__esModule = true;
exports.renderReportListRow = renderReportListRow;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = require("./styledComponents");
var _System = require("../../../../System");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function renderReportListRow(props) {
  var item = props.item,
    selectedIds = props.selectedIds,
    onItemClick = props.onItemClick,
    thumbnailSize = props.thumbnailSize;
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ReportListItem, {
    key: item.id,
    "data-testid": "ReportListItem",
    to: (0, _System.getScreenURL)("Report", item),
    "aria-selected": selectedIds.includes(item.id),
    onClick: typeof onItemClick !== "function" ? undefined : function (e) {
      e.preventDefault();
      onItemClick(item);
    }
  }, /*#__PURE__*/_react["default"].createElement(_styledComponents.ReportListItemThumbnail, {
    width: thumbnailSize,
    height: thumbnailSize,
    report: item
  }), /*#__PURE__*/_react["default"].createElement(_styledComponents.ReportListItemLabel, {
    title: item.name,
    "data-testid": "ReportListItem.label"
  }, item.name));
}